export default class MobileMenu {
   constructor() {
      this.menu = document.querySelector('.navbar__nav')
      this.hamburger = document.querySelector('.hamburger')
      this.close = document.querySelector('.navbar__nav .close')
      this.menuArrows = document.querySelectorAll('.navbar__nav .dropdown');
      this.init()
   }

   init() {
      if (this.menu) {
         this.toggle()
         this.hideOnClick()
         this.submenu();
      }
   }

   toggle() {
      this.hamburger.addEventListener('click', () => {
         this.hamburger.classList.toggle('is-active')
         this.menu.classList.toggle('is-active')
      });

      this.close.addEventListener('click', () => {
          this.hamburger.classList.toggle('is-active')
          this.menu.classList.toggle('is-active')
      });
   }

   hideOnClick() {
      const links = this.menu.querySelectorAll('li a')

      links.forEach(link => {
         link.addEventListener('click', (e) => {
             if (!e.target.matches('.dropdown') ) {
                 this.hamburger.classList.remove('is-active')
                 this.menu.classList.remove('is-active')
             }
         })
      })
   }
   submenu() {
       if ( this.menuArrows.length ) {
           this.menuArrows.forEach(dropdown => {
                dropdown.addEventListener('click', (e) => {
                    e.preventDefault();
                    let submenu = dropdown.parentElement.parentElement.querySelector('.sub-menu');
                    submenu.classList.toggle('sub-menu--opened');
                    dropdown.classList.toggle('dropdown--active');
                })
           });
       }
   }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/mobile-menu.js
// module id = 9
// module chunks = 0